<template>
	<div class="dropdown langdropdown">
		<button  :class="[ main.isavailable ? 'homepage' : '', colorclass ? colorclass : '', (top && main.isavailable) ? '' : '' ]" class="lang-btn btn btn-sm btn-secondary dropdown-toggle text-uppercase" type="button" id="lang" data-bs-offset="0, 13" data-bs-toggle="dropdown" aria-expanded="false">
			<i class="bi bi-globe ms-lg-0 ms-md-0 ms-1"></i> {{ currentLanguage }}
		</button>
		<ul class="dropdown-menu border-0" aria-labelledby="lang">
			<li><a class="dropdown-item" @click="setLang('en')">EN</a></li>
			<li><a class="dropdown-item" @click="setLang('el')">ΕΛ</a></li>
		</ul>
	</div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { userLangStore } from '@/store/userLangStore';
import { userMainStore } from '@/store/userMainStore';
import { useRoute } from 'vue-router';

const route = useRoute();
let qlang = null;
if (route.query.lng == 'el') qlang = 'el';

const main = userMainStore();
const langstore = userLangStore();

defineProps({
	top: Boolean,
	colorclass: String,
})

const t = useI18n();
t.locale.value = qlang || localStorage.getItem('locale') || 'en';
const currentLanguage = ref(t.locale.value);

const setLang = (lang) => {
	currentLanguage.value = lang;
	t.locale.value = lang;
	localStorage.setItem("locale", lang);
	langstore.refreslang = !langstore.refreslang;
	let h = document.querySelector('html');
	h.setAttribute('lang', lang);
}
</script>
<style scoped lang="scss">
.langdropdown {
	min-width: 64px;
}

.dropdown-menu {
	border-radius: 8px;
	background: var(--Background-White, #FFFFFE);
	box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
}

.dropdown-item:hover {
    color: rgba(var(--tt-1-rgb), 1);
    background-color: transparent;
    cursor: pointer;
}

.dropdown-item {
	color: var(--Off-black-100, #161616);
	font-family: Roboto;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 0.5px;
}

.btn {
	border: none;
}

.btn.lang-btn {
	background-color: transparent!important;
}

.btn.lang-btn.mainpage:hover {
	background-color: transparent!important;
}

.btn.lang-btn:hover {
	background-color: #fff;
}

.btn.lang-btn {
	font-weight: 600;
}
</style>